/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const styles = (theme) => {
    const { breakpoints: { minWidth, maxWidth } } = theme;
    return {
        bgsReviewsWrapper: {
            '&.bgsReviewsSlider': {
                position: 'relative',
                width: '100%',
                '& .nextArrow, .prevArrow': {
                    width: '50px',
                    height: '50px',
                    [theme.breakpoints.between(minWidth?.xxs_screen_up, maxWidth?.xs_screen)]: {
                        width: '45px',
                        height: '45px',
                    },
                    [theme.breakpoints.down(maxWidth?.xxs_screen)]: {
                        width: '35px',
                        height: '35px',
                    },
                    padding: '0',
                    position: 'absolute',
                    top: '50%',
                    marginTop: '-28px',
                    background: '#c2c2c2',
                    borderRadius: '50%',
                    display: 'block',
                    zIndex: '100',
                    cursor: 'pointer',
                    borderColor: 'transparent',
                    color: '#ffffff',
                    '& i': {
                        fontSize: '2.188rem',
                        paddingTop: '5px',
                        [theme.breakpoints.down(maxWidth?.xxs_screen)]: {
                            fontSize: '1.563rem',
                            paddingTop: '3px',
                        },
                        [theme.breakpoints.between(minWidth?.xxs_screen_up, maxWidth?.xs_screen)]: {
                            paddingTop: '3px',
                        },
                    },
                    '& :focus, :hover': {
                        outline: 'none !important',
                    },
                },
                '& .nextArrow': {
                    right: '16px',
                    [theme.breakpoints.down(maxWidth?.xxs_screen)]: {
                        right: '24px',
                    },
                    [theme.breakpoints.between(minWidth?.small_screen_down, maxWidth?.medium_screen_down)]: {
                        right: '-20px',
                    },
                    [theme.breakpoints.between(minWidth?.xs_small_screen, maxWidth?.xs_large_screen)]: {
                        right: '33px',
                    },
                    [theme.breakpoints.up(minWidth?.medium_screen_down)]: {
                        right: '-10px',
                    },
                    '& :focus, :hover': {
                        outline: 'none !important',
                    },
                },
                '& .prevArrow': {
                    left: '15px',
                    [theme.breakpoints.down(maxWidth?.xxs_screen)]: {
                        left: '24px',
                    },
                    [theme.breakpoints.between(minWidth?.small_screen_down, maxWidth?.medium_screen_down)]: {
                        left: '-20px',
                    },
                    [theme.breakpoints.up(minWidth?.medium_screen_down)]: {
                        left: '-6px',
                    },
                },
                '& .fullWidth': {
                    maxWidth: '100% !important',
                },
            },
        },
    };
};

export default styles;
